import React, { Fragment, useEffect, useState, useContext } from 'react'
import { Link, withRouter } from 'react-router-dom'
import styled, { css } from 'styled-components';
import { Select } from './Select';

export function UIaddToPlaylists({ playlists, handleChange }) {



  //TODO: dummy playlist handling
  const [activePlaylists, setActivePlaylists] = useState([])
  const playlistHandle = (value) => {
    let newPlaylistArray = JSON.parse(JSON.stringify(activePlaylists))

    if (newPlaylistArray.includes(value)) {
      newPlaylistArray.splice(newPlaylistArray.indexOf(value), 1)
    } else {
      newPlaylistArray.push(value)
    }
    setActivePlaylists(newPlaylistArray)
  }


  useEffect(() => {
    handleChange(activePlaylists)
  }, [activePlaylists])




  return (
    <>
      <div style={{
        position: 'relative',
        zIndex: 2,
      }}>
      <Select
        theme={{
          idle: '#def2f117',
          fontSize: 15,
        }}
        dropStyle={{
          padding: "0.1em",
        }}
        dropItemStyle={{
          borderRadius: "0.2em",
          padding: "0.4em 1em",
          margin: "0.2em",
          minHeight: 32,
        }}
        multiSelect={true}
        width={260}
        // size="sm"
        placeholder="Add to playlist"
        // active = {filter.length ? filter[0] : null }
        active={activePlaylists}
        itemCustom={(item, active) => <PlaylistEntryItem {...item} active={active} />}
        itemActiveCustom={(item) => <PlaylistEntry {...item} />}
        menuHandler={(value) => {
          playlistHandle(value)
        }}
        options={[...playlists,
        {
          separated: true,
          title: 'Create new playlist',
          createNew: true
        }
        ]}
      />

      </div>
    </>
  )
}





//Trigger element
export function PlaylistEntry({
  title = 'Playlist',
  uniq = 'playlist_url_slug',
  emoji,
  active,
}) {


  return (
    <>
      <div className="x_playlist_added">
        <div className="x_playlist_added_ico">
          {!emoji && <div className="ico">playlist_add_check</div>}
          {emoji && <div className="">{emoji}</div>}
        </div>
        <div className="x_button_labels">{title}</div>
      </div>
    </>
  )
}

//Dropdown element
export function PlaylistEntryItem({
  title = 'Playlist',
  uniq = 'playlist_url_slug',
  active,
  emoji,
  createNew,
}) {
  const CSSitem = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
  `
  const CSSgoto = styled.div`
    border-radius: 100px;
    background: white;
    cursor: pointer;
    height: 1.4em;
    width: 1.4em;
    flex-shrink: 0;
    display: flex;
    align-content: center;
    justify-content: center;
    text-decoration: none;
    &:hover {
      background: #06a19a;
      color: white;
    }
  `

  const CSStitle = styled.div`
    flex-grow: 1;
  `

  const CSSico = styled.div`
      padding: 0 0.8em 0 0;
      font-size: 18px;
      `

  return (
    <>


      {!createNew && <CSSitem >
        {/* <CSSico className="x_playlist_added_ico">
          <div className="ico">
            {active ? 'check_box' : 'check_box_outline_blank'}
          </div>
        </CSSico> */}
        <CSSico>
          {!emoji && <div className="ico">list</div>}
          {emoji && <div className="ico">{emoji}</div>}
        </CSSico>
        <CSStitle>
          {title}
        </CSStitle>
        <CSSgoto onClick={(e) => {
          e.stopPropagation();
          //TODO: go to this playlist page
          //(passed via 'playlist_url_slug')
          //not adding the video
          return null
        }}>
          <div className="ico">chevron_right</div>
        </CSSgoto>
      </CSSitem>


      }

      {createNew && <CSSitem
        onClick={(e) => {
          e.stopPropagation()
          void (0)
        }}
      >
        <CSSico className="x_playlist_added_ico">
          <div className="ico">
            add
          </div>
        </CSSico>

        <CSStitle>
          Create new playlist
        </CSStitle>
      </CSSitem>}




    </>
  )
}
